import React from "react";
import ImageSlider from "./ImageSlider.js";

const AboutOffice = () => {
  return (
    <div className="w-full bg-white pb-12" id="about_office">
      <section className="text-gray-600 body-font mx-2">
        <div className="flex flex-col text-center w-full mb-10">
          <h2 className="animate-fade-up sm:text-3xl text-2xl font-semibold text-gray-900 mt-16 mb-4">
            Το ιατρείο
          </h2>
          <p className="lg:w-2/3 mx-auto leading-relaxed text-lg text-gray-600">
            Ο χώρος του ιατρείου είναι πλήρως εξοπλισμένος:
          </p>
        </div>
        <ImageSlider />
      </section>
    </div>
  );
};

export default AboutOffice;
